module.exports = {
  emptyMessage: 'Silakan masukkan tanggal kedaluwarsa kartu',
  expiredMessage: 'Maaf! Kartu yang Anda masukkan telah kedaluwarsa',
  defaultMessage: 'Tanggal kedaluwarsa tidak valid',
};
